import { render, staticRenderFns } from "./Splb.vue?vue&type=template&id=6b53f41f&"
import script from "./Splb.vue?vue&type=script&lang=js&"
export * from "./Splb.vue?vue&type=script&lang=js&"
import style0 from "./Splb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports